module.exports = __webpack_public_path__ + "img/301405577.58a92ee9.jpg";